import { useNavigate } from "react-router-dom";
import React, {useRef, useState, useEffect } from "react";
import logo from "../assets/logo.png";
import down from "../assets/Down.svg";
import icon from "../assets/Icon.png";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import { toast, ToastContainer } from "react-toastify";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import { Link } from "react-router-dom";
import n from "../assets/N.png";
import twit from "../assets/Twit.png";
import right from "../assets/Right.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import trans from "../assets/Trans.png";
import dock from "../assets/Do.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import riarr from "../assets/Rightarr.svg";
import phone from "../assets/Phone.png";
import ee from "../assets/Email.png";
import trial from "../assets/Trial.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";


const Cookie = () => {

 const [selected, setSelected] = useState("Cookie Policy");
      const [screenWidth, setScreenWidth] = useState(window.innerWidth);
      const [isMenuOpen, setIsMenuOpen] = useState(false);
      const navigate = useNavigate();
        const [hoveredItem, setHoveredItem] = useState(null);
      const [activeItem, setActiveItem] = useState("Home");
      const [showDropdown, setShowDropdown] = useState(false);
    
    const policyRoutes = {
      "Terms and Conditions": "/terms",
      "Privacy Policy": "/terms#privacy-policy",
      "Cookie Policy": "/terms#cookie-policy",
      "Copyright Policy": "/terms#copyright-policy",
    };
    
    
      const complianceData = [
        { icon: o1, title: "General Data Protection" },
        { icon: o2, title: "SOC2 Compliance Report" },
        { icon: o3, title: "Data Processing Agreement" },
        { icon: o4, title: "ISO Certification" },
        { icon: o5, title: "VAPT Compliance" },
      ];
    
      const dropdownItems = [
         {
           title: "LOGISTICS OPERATIONS",
           items: [
           {
         name: "Gate",
         description: (
           <>
             Helps organizations track and manage
             <br />
             visitors efficiently.
           </>
         ),
         icon: gate,
       },
             // {
             //   icon: dock,
             //   name: "Dock",
             //   description:
             //     "Helps businesses streamline loading, unloading & scheduling.",
             // },
             // {
             //   icon: sign,
             //   name: "Signage",
             //   description:
             //     "Creating, managing & displaying digital content on screens.",
             // },
           ],
         },
         // {
         //   title: "TRACKING SYSTEM",
         //   items: [
         //     {
         //       icon: trans,
         //       name: "Transport",
         //       description:
         //         "Helps users efficiently manage & optimize transportation services.",
         //     },
         //     {
         //       icon: bus,
         //       name: "Vehicle Management",
         //       description:
         //         "Tracks vehicles, optimizes routes, and automates expenses.",
         //     },
         //     {
         //       icon: asset,
         //       name: "Asset",
         //       description:
         //         "Helps businesses track, monitor, and manage assets efficiently.",
         //     },
         //   ],
         // },
         {
           title: "WORKFORCE MANAGEMENT",
           items: [
            {
         name: "MeetQ",
         description: (
           <>
             Book & manage meeting rooms
             <br />
             with real-time tracking.
           </>
         ),
         icon: q,
       },
             // {
             //   icon: tg,
             //   name: "TickGo",
             //   description: "Track tasks, log hours, and update statuses.",
             // },
             // {
             //   icon: n,
             //   name: "Nexus",
             //   description: "Manage attendance, tasks, and productivity.",
             // },
           ],
         },
       ];
    
    
    
      const policyContent = {
        "Terms and Conditions": (
          <div id="terms-and-conditions"
            style={{
             
              fontFamily: "Epilogue",
              lineHeight: "1.8",
              color: "#374151",
              fontSize: "15px",
              maxWidth: "800px",
            }}
          >
            <h1
              style={{
                color: "#004BA8",
                fontSize: "28px",
                fontWeight: "bold",
                marginBottom: "24px",
                fontFamily: "Epilogue",
                lineHeight: "1.4",
              }}
            >
              Terms and Conditions
            </h1>
            <h3 style={{ fontSize: "17px", fontWeight: "600", marginBottom: "8px" }}>
              Introduction
            </h3>
            <p>
              Welcome to Mawalog. These terms and conditions govern the use of our
              manufacturing, warehouse, and logistics services. By engaging with
              Mawalog, you agree to comply with these terms.
            </p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Services
            </h3>
            <p>
              Mawalog provides manufacturing, warehousing, logistics related
              services, Supply Chain Management and Inventory Management.
            </p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Client Responsibilities
            </h3>
            <p>
              Clients must provide accurate and complete information for efficient
              service delivery. Clients are responsible for ensuring that their
              products comply with all relevant laws and regulations.
            </p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Delivery and Shipping
            </h3>
            <ol style={{ paddingLeft: "20px" }}>
              <li>
                Mawalog is not liable for delays caused by external factors beyond
                our control. Clients must provide accurate shipping information.
              </li>
              <li>
                Mawalog is not responsible for issues arising from incorrect shipping
                details.
              </li>
            </ol>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Storage and Warehousing
            </h3>
            <ol style={{ paddingLeft: "20px" }}>
              <li>
                Mawalog provides secure storage facilities. Clients are responsible
                for insuring their products.
              </li>
              <li>
                Mawalog reserves the right to charge additional fees for storage
                exceeding agreed-upon durations.
              </li>
            </ol>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Quality Assurance
            </h3>
            <ol style={{ paddingLeft: "20px" }}>
              <li>
                Mawalog strives to maintain high-quality standards. Clients must
                report any quality issues within a specified timeframe.
              </li>
              <li>
                Mawalog is not responsible for damages or defective quality products
                caused by product defects.
              </li>
            </ol>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Confidentiality
            </h3>
            <p>
              Mawalog will handle client information with the utmost
              confidentiality. Both parties agree not to disclose confidential
              information without the other party’s consent.
            </p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Termination
            </h3>
            <p>
              Either party may terminate the agreement with written notice, subject
              to the terms outlined in individual service agreements.
            </p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Governing Law
            </h3>
            <p>These terms and conditions are governed by the Indian Laws.</p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Amendments
            </h3>
            <p>
              Mawalog reserves the right to amend these terms and conditions.
              Clients will be notified of any changes.
            </p>
            <h3
              style={{
                fontSize: "17px",
                fontWeight: "600",
                marginTop: "24px",
                marginBottom: "8px",
              }}
            >
              Contact Information
            </h3>
            <p>
              For inquiries or concerns, please contact Mawalog at{" "}
              <a
                href="mailto:support@mawalog.com"
                style={{
                  color: "#1D4ED8",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                support@mawalog.com
              </a>
              .
            </p>
          </div>
        ),
        "Privacy Policy": (
       <div
      id="privacy-policy"
      style={{
        fontFamily: "Epilogue",
        lineHeight: "1.8",
        color: "#374151",
        fontSize: "15px",
        maxWidth: "800px",
        margin: "40px auto",
        padding: "0 16px",
      }}
    >
      <h1
        style={{
          color: "#004BA8",
          fontSize: "28px",
          fontWeight: "bold",
          marginBottom: "24px",
        }}
      >
        Privacy Policy
      </h1>
            <h3 style={{ fontSize: "17px", fontWeight: "600", marginBottom: "8px" }}>
              Introduction
            </h3>
            <p>
              We may collect personal information that you provide to us when using
              our Services, including but not limited to your name, contact
              information, shipping address, and payment details.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Information We Collect Automatically
            </h3>
            <p>
              We may automatically collect certain information when you access or use
              our Services, including your IP address, device information, and
              browsing activity.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Uses of Information
            </h3>
            <p>We may use the information we collect for various purposes, including:</p>
            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
              <li>Processing and fulfilling orders.</li>
              <li>Communicating with you about your account and the Services.</li>
              <li>Improving the products and services.</li>
              <li>Complying with legal obligations.</li>
            </ul>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Location Data
            </h3>
            <p>
              Our app may access or collect location data from your device to provide
              location-based services. You can choose to enable or disable location
              services in your device settings. We only collect location data with
              your consent and use it for the intended purpose of improving user
              experience and service functionality.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Types of Personal and Sensitive User Data Collected
            </h3>
            <p>
              We might have access to or gather the following kinds of sensitive and
              personal information:
            </p>
            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
              <li>Name, email, phone number, and address.</li>
              <li>Payment information for transaction security.</li>
              <li>Device information like OS, storage, and identifiers.</li>
              <li>
                Location and contextual information (with consent) for better app
                experience and support.
              </li>
            </ul>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Secure Data Handling
            </h3>
            <p>We prioritize the security of your personal and sensitive data. Measures include:</p>
            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
              <li>Encryption during transmission and storage.</li>
              <li>Regular security audits.</li>
              <li>Access limitations to data.</li>
            </ul>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Data Retention and Deletion Policy
            </h3>
            <p>
              We keep personal information only as long as needed to achieve the
              goals specified in this policy. When your account is closed, or when
              retention is no longer needed, we securely delete or anonymize your
              data unless legally required to retain it.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Your Choices
            </h3>
            <p>
              You may opt out of providing certain data. You may also opt out of
              receiving promotional communications by following the unsubscribe
              links.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Transparency Regarding Sensitive User and Device Data
            </h3>
            <p>
              We are committed to transparency regarding how we handle sensitive user
              and device data. We describe what data we collect, how we use it, and
              how we secure it, in accordance with applicable privacy regulations.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Children’s Privacy
            </h3>
            <p>
              Our Services are not directed to individuals under 18. We do not
              knowingly collect personal data from children under 18.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              For Users Under 13:
            </h3>
            <p>
              In accordance with data protection laws, we do not collect data from
              users under 13 without parental consent.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Changes to this Privacy Policy
            </h3>
            <p>
              We may update this Privacy Policy from time to time. Any changes will
              be posted on this page, and the effective date will be updated
              accordingly.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Contact Information
            </h3>
            <p>
              If you have any questions or concerns about this Privacy Policy, please
              contact us at{" "}
              <a
                href="mailto:support@mawalog.com"
                style={{
                  color: "#004BA8",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                support@mawalog.com
              </a>{" "}
              or call us at{" "}
              <a
                href="tel:+919144859345"
                style={{
                  color: "#004BA8",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                +91-914-4859-345
              </a>
              .
            </p>
          </div>
        ),
        "Cookie Policy": (
          <div id="cookie-policy"
            style={{
              fontFamily: "Epilogue",
              lineHeight: "1.8",
              color: "#374151",
              fontSize: "15px",
              maxWidth: "800px",
            }}
          >
            <h1
              style={{
                color: "#004BA8",
                fontSize: "28px",
                fontWeight: "bold",
                marginBottom: "24px",
                textTransform: "capitalize",
              }}
            >
              Cookie policy
            </h1>
            <h3 style={{ fontSize: "17px", fontWeight: "600", marginBottom: "8px" }}>
              Introduction
            </h3>
            <p>
              This Cookie Policy explains how we use cookies and similar tracking
              technologies on our website.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              What are cookies?
            </h3>
            <p>
              Cookies are small text files that are stored on your device (computer,
              tablet, smartphone) when you visit a website. They are widely used to
              make websites work more efficiently and to provide information to
              website owners.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Types of Cookies We Use
            </h3>
            <p>
              <strong>Essential Cookies :</strong> <br />
              These cookies are necessary for the website to function properly. They
              enable core functionality such as security, network management, and
              accessibility.
            </p>
            <p style={{ marginTop: "16px" }}>
              <strong>Analytical/Performance Cookies :</strong> <br />
              These cookies allow us to analyze how visitors use our website,
              including which pages they visit and how long they spend on each page.
              This information helps us improve the performance of our website.
            </p>
            <p style={{ marginTop: "16px" }}>
              <strong>Functionality Cookies :</strong> <br />
              These cookies enable enhanced functionality and personalization, such
              as remembering your preferences and settings.
            </p>
            <p style={{ marginTop: "16px" }}>
              <strong>Advertising/Targeting Cookies :</strong> <br />
              These cookies are used to deliver advertisements that are relevant to
              your interests. They may also be used to limit the number of times you
              see an advertisement and measure the effectiveness of advertising
              campaigns.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Consent to Use Cookies
            </h3>
            <p>
              By using our website, you consent to the use of cookies and similar
              tracking technologies as described in this Cookie Policy. You can
              withdraw your consent at any time by deleting cookies from your browser
              and adjusting your browser settings to block cookies or to alert you
              when cookies are being sent. However, please note that disabling
              cookies may affect the functionality of our website.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Third-Party Cookies
            </h3>
            <p>
              We may use third-party cookies on our website for analytics,
              advertising, and other purposes. These third parties may collect
              information about your online activities over time and across different
              websites.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Cookie Management
            </h3>
            <p>
              You can manage your cookie preferences and settings in your web
              browser. Most browsers allow you to control cookies through their
              settings preferences. However, please note that blocking or deleting
              cookies may affect the functionality of our website.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Changes to this Cookie Policy
            </h3>
            <p>
              We may update this Cookie Policy from time to time. Any changes will be
              posted on this page, and the effective date will be updated
              accordingly.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Contact Us
            </h3>
            <p>
              If you have any questions or concerns about this Cookie Policy, please
              contact us at{" "}
              <a
                href="mailto:support@mawalog.com"
                style={{
                  color: "#004BA8",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                support@mawalog.com
              </a>
              .
            </p>
          </div>
        ),
        "Copyright Policy": (
         <div id="copyright-policy"
            style={{
              fontFamily: "Epilogue",
              lineHeight: "1.8",
              color: "#374151",
              fontSize: "15px",
              maxWidth: "800px",
            }}
          >
            <h1
              style={{
                color: "#004BA8",
                fontSize: "28px",
                fontWeight: "bold",
                marginBottom: "24px",
                textTransform: "capitalize",
              }}
            >
              Copyright policy
            </h1>
            <h3 style={{ fontSize: "17px", fontWeight: "600", marginBottom: "8px" }}>
              Introduction
            </h3>
            <p>
              This Copyright Policy governs the use of copyrighted materials on our
              website and outlines our stance on copyright infringement.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Copyright Ownership
            </h3>
            <p>
              Unless otherwise indicated, all content and materials on the Mawalog
              website, including but not limited to text, images, graphics, logos,
              videos, and software, are the intellectual property of Mawalog or its
              licensors and are protected by copyright laws.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Permissible Use
            </h3>
            <p>
              Visitors to the Mawalog website are permitted to view, download, and
              print content for personal, non-commercial use only. <br />
              Users may not modify, reproduce, distribute, transmit, or publicly
              display any copyrighted materials without prior written consent from
              Mawalog.
            </p>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Copyright Infringement
            </h3>
            <p>
              Mawalog respects the intellectual property rights of others and expects
              visitors to our website to do the same.
            </p>
            <p>
              If you believe that your copyrighted work has been used on the MAWALOG
              website in a way that constitutes copyright infringement, please
              contact us promptly with the following information:
            </p>
            <ul style={{ paddingLeft: "20px", marginTop: "12px" }}>
              <li>Identification of the copyrighted work claimed to have been infringed.</li>
              <li>Identification of the allegedly infringing material.</li>
              <li>Your contact information (name, address, email, phone number).</li>
              <li>
                A statement that you have a good faith belief that the use of the
                material is not authorized by the copyright owner.
              </li>
              <li>
                A statement that the information provided in the notice is accurate,
                and under penalty of perjury, you are authorized to act on behalf of
                the copyright owner.
              </li>
            </ul>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Counter-Notice
            </h3>
            <p>
              If you believe that your material was removed or disabled by mistake or
              misidentification, you may send us a counter-notice containing the
              following information:
            </p>
            <ul style={{ paddingLeft: "20px", marginTop: "12px" }}>
              <li>Identification of the material that has been removed or disabled.</li>
              <li>Your contact information (name, address, email, phone number).</li>
              <li>
                A statement under penalty of perjury that you have a good faith
                belief that the material was removed or disabled as a result of
                mistake or misidentification.
              </li>
              <li>
                A statement that you consent to the jurisdiction of the federal
                district court for the judicial district in which your address is
                located.
              </li>
            </ul>
            <h3
              style={{ fontSize: "17px", fontWeight: "600", margin: "24px 0 8px" }}
            >
              Contact Information
            </h3>
            <p>
              For copyright-related inquiries, please contact us at{" "}
              <a
                href="mailto:support@mawalog.com"
                style={{
                  color: "#004BA8",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                support@mawalog.com
              </a>
              .
            </p>
          </div>
        ),
      };
    useEffect(() => {
      const scrollToHash = () => {
        const hash = window.location.hash;
        if (hash) {
          const el = document.querySelector(hash);
          if (el) {
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 100);
          }
        }
      };
    
      scrollToHash();
    
      // Optional: Listen to popstate for back/forward navigation
      window.addEventListener("popstate", scrollToHash);
    
      return () => {
        window.removeEventListener("popstate", scrollToHash);
      };
    }, []);
    
    
    
    
    
      const handleClick = (item) => {
        setActiveItem(item);
        if (item === "Products") {
          setShowDropdown(!showDropdown);
        } else {
          setShowDropdown(false);
        }
        if (item === "Pricing") {
          navigate("/new");
        }
        if (item === "Home") {
          navigate("/");
        }
        if (item === "Say Hello") {
          navigate("/contact");
        }
        if (item === "Partner") {
          navigate("/part");
        }
        setIsMenuOpen(false);
      };
    
      useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
    
       const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
          const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
           const isMobile = screenWidth <= 768;
        const isTablet = screenWidth > 768 && screenWidth <= 1024;
    
    
       
       const [data, setData] = useState("");
         const [sessionid, setSessionid] = useState("");
         const [email, setEmail] = useState("");
         const [token, setToken] = useState("");
         useEffect(() => {
           fetch("https://api-uat.mawalog.com/admin/v2/api/website")
             .then((response) => response.json())
             .then((json) => {
               setData(json.data.captcha_code);
               setSessionid(json.data.session_id);
               setToken(json.data.token);
             })
             .catch((error) => console.error("Error fetching data:", error));
         }, []);
         useEffect(() => {
           const canvas = document.getElementById("captchaCanvas");
           if (canvas) {
             const ctx = canvas.getContext("2d");
             ctx.clearRect(0, 0, canvas.width, canvas.height);
             ctx.font = "bold 18px Arial";
             ctx.fillStyle = "#00377B";
             ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
           }
         }, [data]);
         const handleChange = (e) => {
           setEmail(e.target.value);
         };
          const canvasRef = useRef(null);
           const [captchaValue, setCaptchaValue] = useState(""); // text from API
           const [userCaptcha, setUserCaptcha] = useState("");
         
           /* ------------------------------------------------------------------- API fetch */
           const fetchCaptcha = async () => {
             try {
               const res = await fetch(
                 "https://api-uat.mawalog.com/admin/v2/api/website"
               );
               const json = await res.json();
               setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
             } catch (err) {
               console.error("Error fetching captcha:", err);
             }
           };
         
           /* -- fetch once on mount ------------------------------------------------------- */
           useEffect(() => {
             fetchCaptcha();
           }, []);
         
           /* -- redraw every time captchaValue changes ------------------------------------ */
           useEffect(() => {
             if (!data) return; // nothing to paint yet
             const canvas = canvasRef.current;
             if (!canvas) return;
         
             const ctx = canvas.getContext("2d");
             const W = canvas.width;
             const H = canvas.height;
         
             /* ========= clear & background */
             ctx.clearRect(0, 0, W, H);
             ctx.fillStyle = "#ffffff";
             ctx.fillRect(0, 0, W, H);
         
             /* ========= random faint bezier curves (extra distortion) */
             for (let i = 0; i < 3; i++) {
               ctx.beginPath();
               ctx.moveTo(Math.random() * W, Math.random() * H);
               ctx.bezierCurveTo(
                 Math.random() * W,
                 Math.random() * H,
                 Math.random() * W,
                 Math.random() * H,
                 Math.random() * W,
                 Math.random() * H
               );
               ctx.lineWidth = 1 + Math.random(); // 1-2 px
               ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
               ctx.stroke();
             }
         
             /* ========= characters (uneven) */
             ctx.font = "bold 22px Arial";
             ctx.fillStyle = "#0A3A72";
             const chars = data.toString().split("");
         
             chars.forEach((ch, i) => {
               const angle = (Math.random() - 0.5) * 0.8; // ±23°
               const x = 8 + i * 14 + (Math.random() * 4 - 2);
               const y = 22 + (Math.random() * 6 - 3);
         
               ctx.save();
               ctx.translate(x, y);
               ctx.rotate(angle);
               ctx.fillText(ch, 0, 0);
               ctx.restore();
             });
         
             /* ========= dots */
             for (let i = 0; i < 45; i++) {
               ctx.beginPath();
               ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
               ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
               ctx.fill();
             }
           }, [data]);
         
           /* -- reload button click ------------------------------------------------------- */
           const handleReload = () => {
             fetch("https://api-uat.mawalog.com/admin/v2/api/website")
               .then((response) => response.json())
               .then((json) => {
                 setData(json.data.captcha_code);
                 setSessionid(json.data.session_id);
                 setToken(json.data.token);
               })
               .catch((error) => console.error("Error fetching data:", error));
           };
       
           const handleSubscribe = async () => {
               try {
                 const response = await fetch(
                   "https://api-uat.mawalog.com/admin/v2/api/newsletter",
                   {
                     method: "POST",
                     headers: {
                       "Content-Type": "application/json",
                       "X-CSRF-TOKEN": token,
                     },
                     body: JSON.stringify({
                       session_id: sessionid,
                       captcha: userCaptcha,
                       email: email,
                       type: "Mawalog",
                     }),
                   }
                 );
           
                 const result = await response.json();
                 console.log("Response:", userCaptcha, " ", data);
                 setEmail("");
                setUserCaptcha("");
                 toast(result.message);
               } catch (error) {
                 console.error("Error sending request:", error);
               }
             };




  return (
      <div style={{ fontFamily: "Epilogue"}}>
                   <ToastContainer
              position="bottom-right"
              autoClose={3000}
              style={{ bottom: "80px" }}
            />
           {/* <div
             style={{
               position: "fixed",
               bottom: "20px",
               right: "15px",
               zIndex: 20,
             }}
           >
             <button
               style={{
                 padding: 0,
                 background: "transparent",
                 border: "none",
                 cursor: "pointer",
               }}
             >
               <img
                 src={icon}
                 alt="button icon"
                 style={{ width: "48px", height: "48px" }}
               />
             </button>
           </div> */}
     
     <>
             <div
       style={{
         fontFamily: "Epilogue",
         lineHeight: "1.4",
         top: 0,
         zIndex: 1000,
         display: "flex",
         position: "sticky",
         justifyContent: "space-between",
         alignItems: "center",
         padding: isMobile ? "10px 3%" : "0px 5%",
         backgroundColor: "#fff",
         flexWrap: "wrap",
          borderBottom: "1px solid #ddd",
       }}
     >
     
     <div
       onClick={() => {
         if (window.location.pathname === "/") {
           window.location.reload();
         } else {
           window.location.href = "/";
         }
       }}
       style={{ cursor: "pointer" }}
     >
       <img
         src={logo}
         alt="Logo"
         style={{
           maxWidth: isMobile ? "120px" : "150px",
           height: "auto",
           marginLeft: isMobile ? "-10px" : "-50px",
         }}
       />
     </div>
     
        
                {/* Mobile Hamburger Icon */}
                {isMobile && (
                  <button
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    style={{ background: "none", border: "none", cursor: "pointer" }}
                  >
                    <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  </button>
                )}
        
                {/* Desktop/Tablet Menu */}
                {!isMobile && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexDirection: "row",
                      width: "auto",
                      backgroundColor: "transparent",
                      padding: "0",
                    }}
                  >
     {["Products", "Partner", "Say Hello"].map((item, index) => (
             <div
               key={index}
               style={{ position: "relative", width: "auto" }}
               onMouseEnter={() => {
                 setHoveredItem(item);
                 if (item === "Products") setShowDropdown(true);
               }}
               onMouseLeave={() => {
                 setHoveredItem(null);
                 if (item === "Products") setShowDropdown(false);
               }}
             >
               <div
                 onClick={() => handleClick(item)}
                 style={{
                   fontSize: "clamp(12px, 2vw, 16px)",
                   cursor: "pointer",
                   fontWeight: "normal",
                   backgroundColor:
                     activeItem === item || hoveredItem === item
                       ? "#EAF3FF"
                       : "transparent",
                   padding: "8px 16px",
                   borderRadius: "20px",
                   transition: "background-color 0.3s",
                   display: "flex",
                   alignItems: "center",
                   gap: "6px",
                   justifyContent: "flex-start",
                 }}
               >
                 {item}
                 {item === "Products" && (
                   <img
                     src={down}
                     alt="Down Arrow"
                     style={{
                       width: "10px",
                       height: "7px",
                       transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                       transition: "transform 0.3s",
                     }}
                   />
                 )}
               </div>
     
               {item === "Products" && showDropdown && (
                 <div
                   onMouseEnter={() => setShowDropdown(true)}
                   onMouseLeave={() => setShowDropdown(false)}
                   style={{
                     position: "fixed",
                     top: 30,
                     left: "50%",
                     transform: "translateX(-50%)",
                     zIndex: 9999,
                     marginTop: "20px",
                     backgroundColor: "#FFFFFF",
                     boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                     borderRadius: "24px",
                     overflow: "hidden",
                     width: "min(980px, 90vw)",
                     maxWidth: "100%",
                     padding: "16px",
                     display: "grid",
                     gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                     gap: "16px",
                     boxSizing: "border-box",
                   }}
                 >
                   {dropdownItems.map((section, i) => (
                     <div
                       key={i}
                       style={{
                         paddingRight:
                           i < dropdownItems.length - 1 ? "16px" : undefined,
                         borderRight:
                           i < dropdownItems.length - 1
                             ? "1px solid #E0E0E0"
                             : "none",
                       }}
                     >
                       <div
                         style={{
                           color: "#666",
                           fontWeight: 600,
                           marginBottom: 12,
                           textTransform: "uppercase",
                           fontSize: 12,
                         }}
                       >
                         {section.title}
                       </div>
     
                       {section.items.map((product, j) => (
                         <div
                           key={j}
                           style={{
                             display: "flex",
                             alignItems: "flex-start",
                             gap: 10,
                             padding: "8px",
                             cursor: "pointer",
                             marginBottom: 8,
                             borderRadius: 8,
                             transition: "background-color 0.3s ease",
                           }}
                           onClick={() => {
                             if (product.name === "Gate") navigate("/gate");
                             else if (product.name === "MeetQ") navigate("/meetq");
                           }}
                           onMouseEnter={(e) => {
                             e.currentTarget.style.backgroundColor = "#F0F8FF";
                             const name = e.currentTarget.querySelector(
                               ".product-name"
                             );
                             const arrow = e.currentTarget.querySelector(".arrow-icon");
                             if (name) name.style.color = "#004aad";
                             if (arrow) {
                               arrow.style.filter =
                                 "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                               arrow.style.transform = "translateX(4px)";
                             }
                           }}
                           onMouseLeave={(e) => {
                             e.currentTarget.style.backgroundColor = "transparent";
                             const name = e.currentTarget.querySelector(
                               ".product-name"
                             );
                             const arrow = e.currentTarget.querySelector(".arrow-icon");
                             if (name) name.style.color = "inherit";
                             if (arrow) {
                               arrow.style.filter = "none";
                               arrow.style.transform = "translateX(0)";
                             }
                           }}
                         >
                           <img
                             src={product.icon}
                             alt={product.name}
                             style={{ width: 20, height: 20 }}
                           />
                           <div>
                             <div
                               className="product-name"
                               style={{
                                 fontWeight: 600,
                                 display: "flex",
                                 alignItems: "center",
                                 transition: "color 0.3s ease",
                                 fontSize: 13,
                               }}
                             >
                               {product.name}
                               <img
                                 className="arrow-icon"
                                 src={nr}
                                 alt="arrow"
                                 style={{
                                   marginLeft: 4,
                                   width: 16,
                                   height: 16,
                                   transition: "filter 0.3s ease, transform 0.3s ease",
                                 }}
                               />
                             </div>
                             <div
                               style={{
                                 color: "#666",
                                 fontSize: 12,
                                 textAlign: "left",
                                 lineHeight: 1.4,
                               }}
                             >
                               {product.description}
                             </div>
                           </div>
                         </div>
                       ))}
                     </div>
                   ))}
                 </div>
               )}
             </div>
           ))}
     
        
                    <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                      <button
       onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
       className="login-button"
       style={{
         padding: "10px 20px",
         borderRadius: "20px",
         border: "1px solid #004aad",
         backgroundColor: "#fff",
         color: "#004aad",
         fontWeight: "bold",
         cursor: "pointer",
         fontSize: "16px",
         transition: "background-color 0.3s",
       }}
       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
     >
       Login
     </button>
     
                      <button
                        onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                        className="register-button"
                        style={{
                          padding: "10px 20px",
                          borderRadius: "20px",
                          border: "none",
                          backgroundColor: "#004aad",
                          color: "#fff",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontSize: "16px",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                      >
                        Register
                      </button>
                    </div>
                  </div>
                )}
              </div>
        
              {/* Mobile Menu */}
              {isMobile && isMobileMenuOpen && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#fff",
                    padding: "20px",
                    overflowY: "auto",
                    zIndex: 1001,
                    boxSizing: "border-box",
                    fontFamily: "Epilogue, sans-serif",
                  }}
                >
                  {/* Header with Logo and Close Button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <Link to="/">
       <img
         src={logo}
         alt="Logo"
         style={{ width: "120px", height: "auto", cursor: "pointer" }}
       />
     </Link>
                    <button
                      onClick={() => setIsMobileMenuOpen(false)}
                      style={{ background: "none", border: "none", cursor: "pointer" }}
                    >
                      <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
        
                  {/* Navigation Items */}
                  {["Products", "Partner", "Say Hello"].map((item, index) => (
                    <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                      {item === "Products" ? (
                        <>
                          <div
                            onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                            style={{
                              fontSize: "16px",
                              cursor: "pointer",
                              fontWeight: "600",
                              color: "#004aad",
                              padding: "12px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "8px",
                              transition: "background-color 0.3s",
                              textAlign: "center",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                          >
                            Products
                            <img
                              src={down}
                              alt="Arrow"
                              style={{
                                width: "10px",
                                height: "7px",
                                transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </div>
                          {mobileProductsOpen && (
                            <div
                              style={{
                                marginTop: "12px",
                                padding: "16px",
                                backgroundColor: "#F9FAFB",
                                borderRadius: "12px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "16px",
                                maxWidth: "100%",
                                overflow: "auto",
                                boxSizing: "border-box",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              {dropdownItems.map((section, i) => (
                                <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                                  <div
                                    style={{
                                      color: "#666",
                                      fontWeight: "600",
                                      textTransform: "uppercase",
                                      fontSize: "12px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {section.title}
                                  </div>
                                  {section.items.map((product, j) => (
                                    <div
                                      key={j}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "8px",
                                        cursor: "pointer",
                                        borderRadius: "8px",
                                        transition: "background-color 0.3s ease",
                                        maxWidth: "100%",
                                      }}
                                      onClick={() => {
                                        if (product.name === "Gate") navigate("/gate");
                                        else if (product.name === "MeetQ") navigate("/meetq");
                                        setIsMobileMenuOpen(false);
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#F0F8FF";
                                        const name = e.currentTarget.querySelector(".product-name");
                                        name.style.color = "#004aad";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "transparent";
                                        const name = e.currentTarget.querySelector(".product-name");
                                        name.style.color = "inherit";
                                      }}
                                    >
                                      <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                      <div style={{ flex: 1, overflow: "hidden" }}>
                                        <div
                                          className="product-name"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            transition: "color 0.3s ease",
                                            whiteSpace: "normal",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "center",
                                          }}
                                        >
                                          {product.name}
                                        </div>
                                        <div
                                          style={{
                                            color: "#666",
                                            fontSize: "12px",
                                            lineHeight: "1.4",
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                          }}
                                        >
                                          {product.description}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ))}
                              <a
                                href="#"
                                style={{
                                  color: "#004aad",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  textDecoration: "none",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  padding: "8px",
                                }}
                                onClick={() => setIsMobileMenuOpen(false)}
                              >
                                Explore all products
                                <img
                                  src={right}
                                  alt="arrow"
                                  style={{
                                    marginLeft: "4px",
                                    width: "16px",
                                    height: "16px",
                                    verticalAlign: "middle",
                                  }}
                                />
                              </a>
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          onClick={() => {
                            handleClick(item);
                            setIsMobileMenuOpen(false);
                          }}
                          style={{
                            fontSize: "16px",
                            cursor: "pointer",
                            fontWeight: "600",
                            color: "#004aad",
                            padding: "12px",
                            borderRadius: "8px",
                            transition: "background-color 0.3s",
                            textAlign: "center",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                        >
                          {item}
                        </div>
                      )}
                    </div>
                  ))}
        
                  {/* Buttons */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      width: "100%",
                      marginTop: "20px",
                    }}
                  >
                    <button
                      onClick={() => {
                        window.location.href = "http://app.mawalog.com/login";
                        setIsMobileMenuOpen(false);
                      }}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "20px",
                        border: "1px solid #004aad",
                        backgroundColor: "#fff",
                        color: "#004aad",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "14px",
                        width: "100%",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                    >
                      Login
                    </button>
                    <button
                      onClick={() => {
                        window.open("https://app.mawalog.com/register", "_blank");
                        setIsMobileMenuOpen(false);
                      }}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "20px",
                        border: "none",
                        backgroundColor: "#004aad",
                        color: "#fff",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "14px",
                        width: "100%",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                    >
                      Register
                    </button>
                  </div>
                </div>
              )}
        
              {/* Media Queries for Tablet Button Size */}
              <style>
                {`
                  @media (min-width: 769px) and (max-width: 1024px) {
                    .login-button, .register-button {
                      padding: 8px 16px !important;
                      font-size: 14px !important;
                    }
                  }
                `}
              </style>
            </>
           
     
           <div
             style={{
               display: "flex",
               flexDirection: screenWidth <= 768 ? "column" : "row",
               gap: "20px",
               padding: screenWidth <= 768 ? "20px" : "40px",
             }}
           >
             <div
               style={{
                 display: "flex",
                 flexDirection: "column",
                 borderLeft: screenWidth <= 768 ? "none" : "1px solid #E5E7EB",
                 paddingLeft: screenWidth <= 768 ? "0" : "20px",
                 minWidth: screenWidth <= 768 ? "100%" : "200px",
                 position: screenWidth <= 768 ? "static" : "sticky",
                 top: "80px",
                 zIndex: "1",
                 height: screenWidth <= 768 ? "auto" : "fit-content",
               }}
             >
               {Object.keys(policyRoutes).map((item, index) => {
                 const isSelected = selected === item;
                 return (
                   <div
                     key={index}
                     onClick={() => setSelected(item)}
                     style={{
                       display: "flex",
                       alignItems: "center",
                       marginBottom: "8px",
                       cursor: "pointer",
                       transition: "all 0.3s ease",
                     }}
                   >
                     <div
                       style={{
                         width: "4px",
                         height: "100%",
                         backgroundColor: isSelected ? "#004BA8" : "transparent",
                         borderRadius: "2px",
                         display: screenWidth <= 768 ? "none" : "block",
                       }}
                     />
                     <div
                       style={{
                         marginLeft: "8px",
                         backgroundColor: isSelected ? "#EEF4FF" : "transparent",
                         color: isSelected ? "#004BA8" : "#6B7280",
                         fontWeight: isSelected ? "bold" : "normal",
                         fontSize: screenWidth <= 768 ? "13px" : "15px",
                         padding: screenWidth <= 768 ? "8px 16px" : "10px 20px",
                         borderRadius: "12px",
                         width: screenWidth <= 768 ? "100%" : "auto",
                         textAlign: screenWidth <= 768 ? "center" : "left",
                       }}
                     >
                       {item}
                     </div>
                   </div>
                 );
               })}
             </div>
     
             <div style={{ flex: 1, padding: screenWidth <= 768 ? "10px" : "20px" }}>
               {policyContent[selected]}
             </div>
           </div>
     
          {/* <div
                            style={{
                              fontFamily: "Epilogue",
                              lineHeight: "1.4",
                              padding: "clamp(30px, 5vw, 60px)",
                              marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
                            }}
                          >
                            <div
                              style={{
                                maxWidth: "clamp(800px, 90vw, 1200px)",
                                margin: "0 auto",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    color: "#181835",
                                    fontSize: "clamp(18px, 2.5vw, 22px)",
                                    fontWeight: "bold",
                                    paddingLeft: screenWidth <= 1440 ? "clamp(50px, 10vw, 110px)" : "clamp(100px, 12vw, 170px)",
                                    alignSelf: "flex-start",
                                  }}
                                >
                                  Compliance of our company
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "clamp(10px, 2vw, 15px)",
                                    marginTop: "clamp(15px, 2vw, 20px)",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {complianceData.slice(0, 3).map((item, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: "#F4F7FF",
                                        width: "clamp(200px, 30vw, 270px)",
                                        height: "clamp(35px, 5vw, 40px)",
                                        padding: "clamp(4px, 1vw, 5px)",
                                        borderRadius: "30px",
                                        justifyContent: "space-between",
                                        cursor: "pointer",
                                        transition: "background-color 0.3s, transform 0.3s ease",
                                        marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#EDF4FF";
                                        e.currentTarget.style.transform = "scale(1.03)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#F4F7FF";
                                        e.currentTarget.style.transform = "scale(1)";
                                      }}
                                    >
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <div
                                          style={{
                                            borderRadius: "50%",
                                            padding: "clamp(8px, 1.5vw, 10px)",
                                            marginRight: "clamp(8px, 1.5vw, 12px)",
                                          }}
                                        >
                                          <img
                                            src={item.icon}
                                            alt={item.title}
                                            style={{
                                              width: "clamp(30px, 4vw, 40px)",
                                              height: "clamp(30px, 4vw, 40px)",
                                            }}
                                          />
                                        </div>
                                        <span
                                          style={{
                                            color: "#181835",
                                            fontSize: "clamp(10px, 1.5vw, 12px)",
                                            marginRight: "-10px",
                                          }}
                                        >
                                          {item.title}
                                        </span>
                                      </div>
                                      <img
                                        src={riarr}
                                        alt="Arrow"
                                        style={{
                                          width: "clamp(14px, 2vw, 18px)",
                                          height: "clamp(14px, 2vw, 18px)",
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "clamp(10px, 2vw, 15px)",
                                  marginTop: "clamp(15px, 2vw, 20px)",
                                  flexWrap: "wrap",
                                  marginRight: screenWidth <= 1024 ? "clamp(5px, 2vw, 10px)" : "clamp(100px, 20vw, 290px)",
                                }}
                              >
                                {complianceData.slice(3, 5).map((item, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      backgroundColor: "#F4F7FF",
                                      width: "clamp(200px, 30vw, 270px)",
                                      height: "clamp(35px, 5vw, 40px)",
                                      padding: "clamp(4px, 1vw, 5px)",
                                      borderRadius: "30px",
                                      justifyContent: "space-between",
                                      cursor: "pointer",
                                      transition: "background-color 0.3s, transform 0.3s ease",
                                      marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor = "#EDF4FF";
                                      e.currentTarget.style.transform = "scale(1.03)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor = "#F4F7FF";
                                      e.currentTarget.style.transform = "scale(1)";
                                    }}
                                  >
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                      <div
                                        style={{
                                          borderRadius: "50%",
                                          padding: "clamp(8px, 1.5vw, 10px)",
                                          marginRight: "clamp(8px, 1.5vw, 12px)",
                                        }}
                                      >
                                        <img
                                          src={item.icon}
                                          alt={item.title}
                                          style={{
                                            width: "clamp(30px, 4vw, 40px)",
                                            height: "clamp(30px, 4vw, 40px)",
                                          }}
                                        />
                                      </div>
                                      <span
                                        style={{
                                          color: "#181835",
                                          fontSize: "clamp(10px, 1.5vw, 12px)",
                                          marginRight: "-10px",
                                        }}
                                      >
                                        {item.title}
                                      </span>
                                    </div>
                                    <img
                                      src={riarr}
                                      alt="Arrow"
                                      style={{
                                        width: "clamp(14px, 2vw, 18px)",
                                        height: "clamp(14px, 2vw, 18px)",
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div> */}
         
        <div
                          style={{
                            fontFamily: "Epilogue",
                            lineHeight: "1.4",
                            display: "flex",
                            alignItems: "center",
                            marginTop: "-20px",
                            justifyContent: "center",
                            backgroundColor: "#004BA8",
                            padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
                            color: "#fff",
                          }}
                          className="newsletter-section"
                        >
                          <div
                            style={{
                              marginRight: "clamp(20px, 3vw, 40px)",
                              marginBottom: "clamp(16px, 2vw, 20px)",
                            }}
                          >
                            <img
                              src={news}
                              alt="Newsletter"
                              style={{
                                width: "clamp(150px, 20vw, 200px)",
                                height: "clamp(120px, 15vw, 170px)",
                                animation: "floatImage 3s ease-in-out infinite",
                              }}
                            />
                          </div>
                  
                          <style>
                            {`
                        @keyframes floatImage {
                          0% { transform: translateY(0); }
                          50% { transform: translateY(-10px); }
                          100% { transform: translateY(0); }
                        }
                  
                        @media (max-width: 480px) {
                          .newsletter-section {
                            flex-direction: column;
                            text-align: center;
                            padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
                          }
                          .newsletter-section > div:first-child {
                            margin-right: 0;
                            margin-bottom: clamp(16px, 2vw, 20px);
                          }
                          .newsletter-section h2,
                          .newsletter-section p,
                          .newsletter-section > div > div,
                          .newsletter-section > div > div:last-child {
                            margin-left: 0;
                          }
                          .newsletter-section .newsletter-input {
                            min-width: clamp(200px, 80vw, 260px);
                          }
                          .newsletter-section button {
                          
                            display: block;
                          }
                        }
                      `}
                          </style>
                  
                           <div className="newsletter-content">
               {/* Title and Paragraph */}
               <>
                 <style>
                   {`
           .newsletter-text {
             font-family: Epilogue;
             line-height: 1.4;
             font-size: 22px;
             margin-bottom: 10px;
             margin-left: 60px;
           }
     
           @media (max-width: 1024px) {
             .newsletter-text {
               font-size: 20px;
               margin-left: 50px;
             }
           }
     
           @media (max-width: 768px) {
             .newsletter-text {
               font-size: 18px;
               margin-left: 40px;
             }
           }
     
           @media (max-width: 480px) {
             .newsletter-text {
               font-size: 16px;
               margin-left: 30px;
             }
           }
         `}
                 </style>
     
                 <div className="newsletter-text">Subscribe to our Newsletter!</div>
               </>
     
               <>
                 <style>
                   {`
           .newsletter-description {
             font-size: 14px;
             margin-bottom: 20px;
             text-align: start;
             margin-left: 60px;
             max-width: 100%;
             box-sizing: border-box;
           }
     
           @media (max-width: 1024px) {
             .newsletter-description {
               font-size: 13px;
               margin-left: 50px;
             }
           }
     
           @media (max-width: 768px) {
             .newsletter-description {
               font-size: 12.5px;
               margin-left: 40px;
             }
           }
     
           @media (max-width: 480px) {
             .newsletter-description {
               font-size: 9px; /* reduced more for small screens */
               text-align: center;
           
             }
           }
         `}
                 </style>
     
                 <div className="newsletter-description">
                   Stay updated with our latest news, offers, and insights! Subscribe{" "}
                   <br />
                   for exclusive updates delivered straight to your inbox.
                 </div>
               </>
     
               
             <>
       <style>
         {`
           .input-wrapper {
             display: flex;
             align-items: center;
             position: relative;
             width: 100%;
             max-width: 400px;
             margin: 0 auto 10px auto; /* center aligned */
             flex-wrap: nowrap;
           }
     
           .email-input {
             padding: 14px 16px 14px 48px;
             border-radius: 10px;
             border: 1px solid #9FCAFF;
             outline: none;
             background-color: #00377B;
             color: #fff;
             flex: 1;
             width: 100%;
             box-sizing: border-box;
             font-size: 16px;
           }
     
           .email-icon {
             position: absolute;
             left: 16px;
             width: 20px;
             height: 20px;
           }
     
           /* Optional: Keep consistent appearance on all devices */
           @media (max-width: 480px) {
             .email-input {
               padding: 12px 12px 12px 44px;
               font-size: 14px;
             }
           }
         `}
       </style>
     
       <div
         style={{
           display: "flex",
           alignItems: "center",
           flexWrap: "wrap",
           justifyContent: "center",
         }}
       >
         <div className="input-wrapper">
           <img src={mail} alt="Email Icon" className="email-icon" />
           <input
             type="email"
             value={email}
             placeholder="sample@gmail.com"
             className="email-input"
             onChange={handleChange}
           />
         </div>
       </div>
     </>
     
     
              
               <>
                 <style>{`
             .captcha-container {
               display: flex !important;
               align-items: center !important;
               justify-content: center !important;
               margin: 10px auto !important;
               border-radius: 20px !important;    
               gap: 8px !important;
               flex-wrap: wrap !important;
             }
           .captcha-box {
       width: 60px !important;
       height: 40px !important;
       border-radius: 8px !important;
       background-color: #fff !important;
       box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
       display: flex !important;
       align-items: center !important;
       justify-content: center !important;
       overflow: hidden !important; /* Add this to clip canvas overflow */
     }
     
     #captchaCanvas {
       border-radius: 20px !important;
     }
             .captcha-input {
               padding:10px 1px!important;
               border-radius:8px!important;
               border:1px solid #ccc!important;
               outline:none!important;
               min-width:120px!important;
               background:#00377B!important;
               color:#fff!important;
             }
             .subscribe-button {
               padding:14px 30px!important;
               border-radius:12px!important;
               border:none!important;
               background:#fff!important;
               color:#0A3A72!important;
               font-weight:bold!important;
               cursor:pointer!important;
               margin-bottom:0!important;
             }
             @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
             @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
             @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
           `}</style>
     
                 <div className="captcha-container">
                   <div className="captcha-box">
                     <canvas
                       ref={canvasRef}
                       id="captchaCanvas"
                       width={60}
                       height={40}
                     />
                   </div>
     
                   <button
                     onClick={handleReload}
                     style={{
                       background: "#2563EB",
                       color: "#fff",
                       border: "none",
                       padding: "8px",
                       borderRadius: "8px",
                       cursor: "pointer",
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                     }}
                   >
                     {/* Your reload SVG icon here */}
                     <svg
                       xmlns="http://www.w3.org/2000/svg"
                       width="22"
                       height="22"
                       viewBox="0 0 24 24"
                       fill="none"
                       stroke="white"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     >
                       <polyline points="23 4 23 10 17 10"></polyline>
                       <polyline points="1 20 1 14 7 14"></polyline>
                       <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                     </svg>
                   </button>
     
                   <input
                     type="text"
                     placeholder="Enter captcha"
                     value={userCaptcha}
                     onChange={(e) => setUserCaptcha(e.target.value)}
                     className="captcha-input"
                   />
     
                   <button className="subscribe-button" onClick={handleSubscribe}>
                     Subscribe
                   </button>
                 </div>
               </>
     
               {/* Note */}
               <div
                 style={{
                   fontSize: "12px",
                   marginTop: "10px",
                   color: "#fff",
                   marginLeft:
                     window.innerWidth <= 480
                       ? "20px"
                       : window.innerWidth <= 768
                       ? "40px"
                       : window.innerWidth <= 1024
                       ? "50px"
                       : "60px",
                 }}
               >
                 *Unsubscribe anytime. We don’t send any spam
               </div>
             </div>
                        </div>
         
         
          <div
       style={{
         fontFamily: "Epilogue",
         lineHeight: "1.4",
         display: "flex",
         justifyContent: "space-between",
         padding: isMobile ? "20px 10px" : "40px",
         backgroundColor: "#fff",
         flexWrap: "wrap",
         maxWidth: "1200px",
         margin: "0 auto",
         boxSizing: "border-box",
       }}
     >
       <div
         style={{
           maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
           marginBottom: "40px",
         }}
       >
         <Link to="/">
           <img
             src={logo}
             alt="Mawalog"
             style={{
               width: isMobile ? "150px" : "180px",
               height: "auto",
               display: "flex",
               justifyContent: "start",
               cursor: "pointer"  // shows it's clickable
             }}
           />
         </Link>
         <p
           style={{
             color: "#555",
             fontSize: isMobile ? "12px" : "14px",
             lineHeight: "1.6",
             textAlign: "start",
             marginBottom: isMobile ? "20px" : "100px",
           }}
         >
           At Mawalog, we believe in simplifying the complexities of supply chain
           management by offering an integrated platform that combines manufacturing,
           logistics, and warehouse solutions partner with optimized logistics and a
           global network.
         </p>
         <div
           style={{
             display: "flex",
             gap: "12px",
             marginTop: isMobile ? "0" : "-80px",
           }}
         >
           {[insta, face, youtube, link,twit].map((icon, index) => (
             <img
               key={index}
               src={icon}
               alt={`icon-${index}`}
               style={{
                 width: isMobile ? "20px" : "24px",
                 height: isMobile ? "20px" : "24px",
                 cursor: "pointer",
                 transition: "transform 0.3s ease",
                 transformOrigin: "center",
               }}
               onMouseEnter={(e) =>
                 (e.currentTarget.style.transform = "scale(1.4)")
               }
               onMouseLeave={(e) =>
                 (e.currentTarget.style.transform = "scale(1)")
               }
               onClick={() => {
                 if (icon === face)
                   window.open("https://www.facebook.com/mawalogone/", "_blank");
                 if (icon === youtube)
                   window.open("https://www.youtube.com/@mawalogone", "_blank");
                 if (icon === insta)
                   window.open("https://www.instagram.com/mawalogone/", "_blank");
                 if (icon === link)
                   window.open(
                     "https://www.linkedin.com/company/mawalogone/",
                     "_blank"
                   )
                   if (icon === twit)
                   window.open("https://x.com/mawalogone", "_blank");
               }}
             />
           ))}
         </div>
       </div>
     
       <div
       style={{
         display: "flex",
         gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
         flexWrap: "wrap",
         justifyContent: isMobile ? "flex-start" : "space-between",
       }}
     >
       <div>
         <h4
           style={{
             fontSize: isMobile ? "12px" : "14px",
             fontWeight: "bold",
           }}
         >
           Know More
         </h4>
     {["Opportunities", "Articles", "Our Story", "Help Center"].map(
       (item, index) => (
         <p
           key={index}
           style={{
             margin: "8px 0",
             color: "#555",
             cursor: "pointer",
             textAlign: "start",
             fontSize: isMobile ? "12px" : "14px",
             transition: "color 0.3s ease",
             paddingBottom: "2px",
           }}
           onClick={() => {
             switch (item) {
               case "Opportunities":
               case "Articles":
               case "Help Center":
                 navigate("/coming");
                 break;
               case "Our Story":
                 navigate("/about");
                 break;
             }
           }}
           onMouseEnter={(e) => {
             e.currentTarget.style.color = "#3B82F6";
           }}
           onMouseLeave={(e) => {
             e.currentTarget.style.color = "#555";
           }}
         >
           {item}
         </p>
       )
     )}
     
       </div>
     
      <div>
           <h4
             style={{
               fontSize: isMobile ? "12px" : "14px",
               fontWeight: "bold",
               marginRight: isMobile ? "0" : "20px",
             }}
           >
             Legal &amp; Policies
           </h4>
     
      {[
       "Terms and Conditions",
       "Privacy Policy",
       "Cookie Policy",
       "Copyright Policy",
     ].map((item, index) => (
       <p
         key={index}
         style={{
           margin: "8px 0",
           color: "#555",
           cursor: "pointer",
           textAlign: "start",
           fontSize: isMobile ? "12px" : "14px",
           transition: "color 0.3s ease",
           paddingBottom: "2px",
         }}
         onClick={() => {
           const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
           const basePath =
             item === "Terms and Conditions"
               ? "/terms"
               : item === "Privacy Policy"
               ? "/policy"
               : item === "Cookie Policy"
               ? "/cookie"
               : item === "Copyright Policy"
               ? "/copyright"
               : "/";
           navigate(`${basePath}${targetId}`);
         }}
         onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
         onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
       >
         {item}
       </p>
     ))}
     
         </div>
     
     </div>
     
     
       <div style={{ marginBottom: "40px" }}>
         <h4
           style={{
             fontSize: isMobile ? "12px" : "14px",
             fontWeight: "bold",
             marginRight: isMobile ? "0" : "180px",
           }}
         >
           Contact us
         </h4>
         <a
           href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
           target="_blank"
           rel="noopener noreferrer"
           style={{
             color: "#004BA8",
             cursor: "pointer",
             fontSize: isMobile ? "12px" : "14px",
             textAlign: "start",
             textDecoration: "none",
             display: "flex",
             alignItems: "center",
           }}
         >
           <img
             src={ee}
             alt="Email"
             style={{
               width: isMobile ? "12px" : "14px",
               height: isMobile ? "12px" : "14px",
               marginRight: "8px",
             }}
           />
           info@mawalog.com
         </a>
         {[
           { phone: "603-27700-311", country: "Malaysia" },
           { phone: "+971-50-1234567", country: "UAE" },
           { phone: "+44 7911 123456", country: "UK" },
           { phone: "+91-44-4856-3345", country: "India" },
         ].map((contact, index) => (
           <p
             key={index}
             style={{
               fontSize: isMobile ? "12px" : "14px",
               textAlign: "start",
             }}
           >
             <img
               src={phone}
               alt="Phone"
               style={{
                 width: isMobile ? "12px" : "14px",
                 height: isMobile ? "12px" : "14px",
                 marginRight: "8px",
               }}
             />
             <a
               href={`tel:${contact.phone}`}
               style={{
                 color: "#004BA8",
                 cursor: "pointer",
                 textDecoration: "none",
               }}
             >
               {contact.phone}
             </a>{" "}
             (<span style={{ color: "#000" }}>{contact.country}</span>)
           </p>
         ))}
       </div>
     
       <div
         className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
         style={{ marginBottom: "40px", position: "relative" }}
       >
         <div style={{ position: "relative", display: "inline-block" }}>
           <a
             href="https://app.mawalog.com/register"
             target="_blank"
             rel="noopener noreferrer"
           >
             <img
               src={trial}
               alt="Illustration"
               style={{
                 width: isMobile ? "180px" : isTablet ? "200px" : "210px",
                 height: "auto",
                 display: "block",
                 cursor: "pointer",
               }}
             />
           </a>
           <div
             style={{
               position: "absolute",
               top: 0,
               left: 0,
               width: "100%",
               height: "100%",
               overflow: "hidden",
               pointerEvents: "none",
               zIndex: 2,
             }}
           >
             <div
               style={{
                 position: "absolute",
                 top: 0,
                 left: "-100%",
                 width: "100%",
                 height: "100%",
                 background:
                   "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
                 animation: "shine 3s ease-in-out infinite",
               }}
             ></div>
           </div>
         </div>
         <style>
           {`
             @keyframes shine {
               0% { left: -100%; }
               100% { left: 100%; }
             }
           `}
         </style>
       </div>
     </div>
         
               <div
                 style={{
                   fontFamily: "Epilogue",
                   lineHeight: "1.4",
                   textAlign: "center",
                   padding: "clamp(16px, 2vw, 20px) 0",
                   borderTop: "1px solid #ddd",
                   fontSize: "clamp(12px, 1.5vw, 14px)",
                   color: "#333",
                 }}
               >
                 Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
               </div>
     
           
         </div>
  )
}

export default Cookie